import React, { useEffect, useRef, useState } from "react";
import { Button, CheckPicker, Checkbox, Loader, Modal } from "rsuite";
import "./nextTier.scss";
import { useDispatch } from "react-redux";
import {
  getNIANextTierOppdata,
  getNextTierFilters,
} from "../../queries/apiQueries";
import SpendGrowthRebate from "./spendGrowthRebate";
import NextTierTable from "./nextTierTable";

const NextTier = () => {
  const dispatch = useDispatch<any>();

  const footerStyles = {
    padding: "10px 2px",
    borderTop: "1px solid #e5e5e5",
  };

  const [nextTierData, setNextTierData] = useState<any>({});
  const [rebateData, setRebateData] = useState<any>({});
  const [summaryData, setSummaryData] = useState<any>({});
  const [pageNumber, setPageNumber] = useState(1);
  const [filtersLoading, setFiltersLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedVendor, setSelectedVendor] = useState<any>("");
  const [selectedRebateCategory, setselectedRebateCategory] = useState<any>("");
  const [chartsData, setChartsData] = useState<any>({});

  const [charts, setCharts] = useState<{ targetSpend: Array<any>, niaRebate: Array<any> }>({ targetSpend: [], niaRebate: [] });

  const [filterOptions, updateFilterOptions] = useState<any>({
    l1: new Array<{ l1: string }>(),
    l2: new Array<{ l2: string }>(),
    l3: new Array<{ l3: string }>(),
    district: new Array<{ district: string }>(),
    supplier: new Array<{ vendor: string }>(),
  });

  const [selectedFilters, setSelectedFilters] = useState<any>({
    l1: [],
    l2: [],
    l3: [],
    district: [],
    supplier: [],
  });

  useEffect(() => {
    getFilters();
    getNextTierdata();
  }, []);

  useEffect(() => {
    getNextTierdata({
      vendor_name: selectedFilters.supplier,
      L1: selectedFilters.l1,
      L2: selectedFilters.l2,
      L3: selectedFilters.l3,
      district: selectedFilters.district,
      pageNumber: [pageNumber],
      pageSize: [10],
      orderBy: ["spend"],
      order: ["Desc"],
    });
  }, [pageNumber])

  /* Next tier data */
  const getNextTierdata = async (payload: any = {}) => {
    if (!Object.keys(payload).length) {
      payload = {
        vendor_name: [],
        L1: [],
        L2: [],
        L3: [],
        district: [],
        pageNumber: [1],
        pageSize: [10],
        orderBy: ["spend"],
        order: ["Desc"],
      };
    } else if (payload.supplier) {
      payload.vendor_name = payload.supplier;
      delete payload.supplier;
    }
    let res = await dispatch(getNIANextTierOppdata(payload));
    setNextTierData(res);
    setIsLoading(false);
  };

  /* Filters api call */
  const getFilters = async (payload: any = {}, currentFilter: any = "all") => {
    setFiltersLoading(true);
    setselectedRebateCategory("");
    setSelectedVendor("");
    if (payload.supplier) {
      payload.vendor_name = payload.supplier;
      delete payload.supplier;
    }
    let res = await dispatch(getNextTierFilters(payload));
    if (currentFilter === "district") {
      updateFilterOptions({
        ...filterOptions,
        l1: [...res.l1],
        l2: [...res.l2],
        l3: [...res.l3],
        supplier: [...res.suppliers],
      });
    } else if (currentFilter === "l1") {
      updateFilterOptions({
        ...filterOptions,
        l2: [...res.l2],
        l3: [...res.l3],
        supplier: [...res.suppliers],
      });
    } else if (currentFilter === "l2") {
      updateFilterOptions({
        ...filterOptions,
        l3: [...res.l3],
        supplier: [...res.suppliers],
      });
    } else if (currentFilter === "l3") {
      updateFilterOptions({ ...filterOptions, supplier: [...res.suppliers] });
    } else if (currentFilter === "supplier") {
      updateFilterOptions({ ...filterOptions });
    } else {
      updateFilterOptions({
        l1: res.l1,
        l2: res.l2,
        l3: res.l3,
        district: res.districts,
        supplier: res.suppliers,
      });
    }
    setIsLoading(false);
    setFiltersLoading(false);
  };

  /* Updating filter selection state  */
  const handleFilterUpdate = (value: any, filter: string) => {
    let x: string = filter;
    if (value === "all") {
      if (filterOptions?.[x].length === selectedFilters?.[x].length) {
        setSelectedFilters({ ...selectedFilters, [x]: [] });
      } else {
        if (x == "supplier") {
          setSelectedFilters({
            ...selectedFilters,
            [x]: [...filterOptions?.[x].map((option: any) => option.vendor)],
          });
        } else {
          setSelectedFilters({
            ...selectedFilters,
            [x]: [...filterOptions?.[x].map((option: any) => option?.[x])],
          });
        }
      }
    } else {
      setSelectedFilters({ ...selectedFilters, [x]: [...value] });
    }
  };

  /* Updating filter options based on selection (api) */
  const handleClose = (filter: string) => {
    if (filter === "district") {
      setSelectedFilters({
        ...selectedFilters,
        l1: [],
        l2: [],
        l3: [],
        supplier: [],
      });
      getFilters(
        { ...selectedFilters, l1: [], l2: [], l3: [], supplier: [] },
        "district"
      );
      getNextTierdata({
        ...selectedFilters,
        l1: [],
        l2: [],
        l3: [],
        supplier: [],
        pageNumber: [1],
        pageSize: [10],
        orderBy: ["spend"],
        order: ["Desc"],
      });
    }
    if (filter === "l1") {
      setSelectedFilters({ ...selectedFilters, l2: [], l3: [], supplier: [] });
      getFilters({ ...selectedFilters, l2: [], l3: [], supplier: [] }, "l1");
      getNextTierdata({
        ...selectedFilters, l2: [], l3: [], supplier: [], pageNumber: [1],
        pageSize: [10],
        orderBy: ["spend"],
        order: ["Desc"]
      });
    }
    if (filter === "l2") {
      setSelectedFilters({ ...selectedFilters, l3: [], supplier: [] });
      getFilters({ ...selectedFilters, l3: [], supplier: [] }, "l2");
      getNextTierdata({
        ...selectedFilters, l3: [], supplier: [], pageNumber: [1],
        pageSize: [10],
        orderBy: ["spend"],
        order: ["Desc"]
      });
    }
    if (filter === "l3") {
      setSelectedFilters({ ...selectedFilters, supplier: [] });
      getFilters({ ...selectedFilters, supplier: [] }, "l3");
      getNextTierdata({
        ...selectedFilters, supplier: [], pageNumber: [1],
        pageSize: [10],
        orderBy: ["spend"],
        order: ["Desc"]
      });
    }
    if (filter === "supplier") {
      getFilters({ ...selectedFilters }, "supplier");
      getNextTierdata({
        ...selectedFilters, pageNumber: [1],
        pageSize: [10],
        orderBy: ["spend"],
        order: ["Desc"],
      });
    }
  };

  useEffect(() => {
    if (nextTierData?.data?.length > 0) {
      let chartData = {
        "spendChartData": [
          {
            quarter: 'Q1',
            actual: 0,
            forecastedSpend: 0,
            spendNeededForNextTier: 0
          },
          {
            quarter: 'Q2',
            actual: 0,
            forecastedSpend: 0,
            spendNeededForNextTier: 0
          },
          {
            quarter: 'Q3',
            actual: 0,
            forecastedSpend: 0,
            spendNeededForNextTier: 0
          },
          {
            quarter: 'Q4',
            actual: 0,
            forecastedSpend: 0,
            spendNeededForNextTier: 0
          }
        ],
        "niaChartData": [
          {
            quarter: 'Q1',
            forecastBase: 0,
            forecastGrowth: 0,
            additionalBase: 0,
            additionalGrowth: 0
          },
          {
            quarter: 'Q2',
            forecastBase: 0,
            forecastGrowth: 0,
            additionalBase: 0,
            additionalGrowth: 0
          },
          {
            quarter: 'Q3',
            forecastBase: 0,
            forecastGrowth: 0,
            additionalBase: 0,
            additionalGrowth: 0
          },
          {
            quarter: 'Q4',
            forecastBase: 0,
            forecastGrowth: 0,
            additionalBase: 0,
            additionalGrowth: 0
          }
        ]
      }

      for (let i = 0; i < chartData.spendChartData.length; i++) {
        let q = chartData.spendChartData[i].quarter;
        chartData.spendChartData[i].actual = chartsData.spendChartData[q]?.actual || 0;

        chartData.spendChartData[i].forecastedSpend = chartsData.spendChartData[q]?.forecastedSpend || 0;

        chartData.spendChartData[i].spendNeededForNextTier = chartsData.spendChartData[q]?.spendNeededForNextTier || 0;

        chartData.niaChartData[i].forecastBase = chartsData.niaChartData[q]?.forecastBase || 0;

        chartData.niaChartData[i].forecastGrowth = chartsData.niaChartData[q]?.forecastGrowth || 0;

        chartData.niaChartData[i].additionalBase = chartsData.niaChartData[q]?.additionalBase || 0;

        chartData.niaChartData[i].additionalGrowth = chartsData.niaChartData[q]?.additionalGrowth || 0;
      }

      setCharts({
        targetSpend: chartData.spendChartData,
        niaRebate: chartData.niaChartData
      })
    }
  }, [chartsData])

  return isLoading ? (
    <Loader size="md" inverse center content="loading..." />
  ) : (
    <div className="next-tier-dashboard-container w-full px-10">
      <div className="flex h-[10%] justify-end">
        {/* Filters */}
        <div className="filter-flex">
          <div className="sub-heading-text">
            <span>District</span>
            <CheckPicker
              data={
                filterOptions?.district.length ? filterOptions?.district : []
              }
              placeholder="All"
              labelKey="district"
              valueKey="district"
              value={selectedFilters.district ? selectedFilters.district : []}
              onClose={() => handleClose("district")}
              // onClean={() => { handleClear("district") }}
              onChange={(value: any) => handleFilterUpdate(value, "district")}
              cleanable={false}
              loading={filtersLoading}
              renderExtraFooter={() => (
                <div style={footerStyles}>
                  <Checkbox
                    indeterminate={
                      selectedFilters.district.length > 0 &&
                      selectedFilters.district.length <
                      filterOptions?.district.length
                    }
                    checked={
                      selectedFilters.district.length ===
                      filterOptions?.district.length
                    }
                    onChange={(value: any) =>
                      handleFilterUpdate("all", "district")
                    }
                  >
                    Check all
                  </Checkbox>
                </div>
              )}
            />
          </div>

          <div className="sub-heading-text">
            <span>L1</span>
            <CheckPicker
              // label="L1"
              data={filterOptions?.l1.length ? filterOptions?.l1 : []}
              placeholder="All"
              labelKey="l1"
              valueKey="l1"
              value={selectedFilters.l1.length ? selectedFilters.l1 : []}
              onClose={() => handleClose("l1")}
              onChange={(value: any) => handleFilterUpdate(value, "l1")}
              // onClean={() => { handleClear("l1") }}
              cleanable={false}
              loading={filtersLoading}
              renderExtraFooter={() => (
                <div style={footerStyles}>
                  <Checkbox
                    indeterminate={
                      selectedFilters.l1.length > 0 &&
                      selectedFilters.l1.length < filterOptions?.l1.length
                    }
                    checked={
                      selectedFilters.l1.length === filterOptions?.l1.length
                    }
                    onChange={(value: any) => handleFilterUpdate("all", "l1")}
                  >
                    Check all
                  </Checkbox>
                </div>
              )}
            />
          </div>

          <div className="sub-heading-text">
            <span>L2</span>
            <CheckPicker
              // label="L2"
              data={filterOptions?.l2.length ? filterOptions?.l2 : []}
              placeholder="All"
              labelKey="l2"
              valueKey="l2"
              value={selectedFilters.l2.length ? selectedFilters.l2 : []}
              onClose={() => handleClose("l2")}
              onChange={(value: any) => handleFilterUpdate(value, "l2")}
              // onClean={() => { handleClear("l2") }}
              cleanable={false}
              loading={filtersLoading}
              renderExtraFooter={() => (
                <div style={footerStyles}>
                  <Checkbox
                    indeterminate={
                      selectedFilters.l2.length > 0 &&
                      selectedFilters.l2.length < filterOptions?.l2.length
                    }
                    checked={
                      selectedFilters.l2.length === filterOptions?.l2.length
                    }
                    onChange={(value: any) => handleFilterUpdate("all", "l2")}
                  >
                    Check all
                  </Checkbox>
                </div>
              )}
            />
          </div>

          <div className="sub-heading-text">
            <span>L3</span>
            <CheckPicker
              // label="L3"
              data={filterOptions?.l3.length ? filterOptions?.l3 : []}
              placeholder="All"
              labelKey="l3"
              valueKey="l3"
              value={selectedFilters.l3.length ? selectedFilters.l3 : []}
              onClose={() => handleClose("l3")}
              onChange={(value: any) => handleFilterUpdate(value, "l3")}
              // onClean={() => { handleClear("l3") }}
              cleanable={false}
              loading={filtersLoading}
              renderExtraFooter={() => (
                <div style={footerStyles}>
                  <Checkbox
                    indeterminate={
                      selectedFilters.l3.length > 0 &&
                      selectedFilters.l3.length < filterOptions?.l3.length
                    }
                    checked={
                      selectedFilters.l3.length === filterOptions?.l3.length
                    }
                    onChange={(value: any) => handleFilterUpdate("all", "l3")}
                  >
                    Check all
                  </Checkbox>
                </div>
              )}
            />
          </div>

          <div className="sub-heading-text">
            <span>Supplier</span>
            <CheckPicker
              // label="Supplier"
              data={
                filterOptions?.supplier.length ? filterOptions?.supplier : []
              }
              placeholder="All"
              labelKey="vendor"
              valueKey="vendor"
              virtualized
              value={
                selectedFilters.supplier.length ? selectedFilters.supplier : []
              }
              onClose={() => handleClose("supplier")}
              onChange={(value: any) => handleFilterUpdate(value, "supplier")}
              // onClean={() => { handleClear("supplier") }}
              cleanable={false}
              loading={filtersLoading}
              renderExtraFooter={() => (
                <div style={footerStyles}>
                  <Checkbox
                    indeterminate={
                      selectedFilters.supplier.length > 0 &&
                      selectedFilters.supplier.length <
                      filterOptions?.supplier.length
                    }
                    checked={
                      selectedFilters.supplier.length ===
                      filterOptions?.supplier.length
                    }
                    onChange={(value: any) =>
                      handleFilterUpdate("all", "supplier")
                    }
                  >
                    Check all
                  </Checkbox>
                </div>
              )}
            />
          </div>
        </div>
      </div>

      <div className="chart-flex h-[80%]">
        <div className="suppliers">
          <NextTierTable
            data={nextTierData?.data}
            count={nextTierData?.count}
            selectedVendor={selectedVendor}
            updateVendor={(vendor: any) => {
              if (vendor != selectedVendor) {
                setSelectedVendor(vendor);
              }
            }}
            selectedRebateCategory={selectedRebateCategory}
            updateRebateData={(rebate: any) => {
              setRebateData(rebate);
            }}
            updateSummaryData={(summary: any) => {
              setSummaryData(summary);
            }}
            updatePageNumber={(page: any) => {
              setPageNumber(page);
            }}
            pageNumber={pageNumber}
            updateRebateCategory={(rebateCategory: any) => {
              if (rebateCategory != selectedRebateCategory) {
                setselectedRebateCategory(rebateCategory);
              }
            }}

            updateChartData={(data: any) => setChartsData(data)}
          />
        </div>
        <div className="detailed-data-container">
          {selectedVendor === "" || selectedRebateCategory === "" ? (
            <div className="msg-container italic font-bold text-lg">
              <h1>Please select the Supplier to see its Peer benchmarks</h1>
            </div>
          ) : (
            <SpendGrowthRebate rebate={rebateData} summary={summaryData} targetSpendChartData={charts.targetSpend} niaRebateChartData={charts.niaRebate} />
          )}
        </div>
      </div>
    </div>
  );
};

export default NextTier;
